<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">
      <b-tab :title="lang.tab_Tasks" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 0">

        <TasksComponent :lang="lang.Tasks" parent="details"></TasksComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_WhereUse" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 1">
        <span v-if="appConf.status.isPRM">
          <WhereUseTableComponent :parent="'parts'" :lang="lang.WhereUse"></WhereUseTableComponent>
          <br><br>
        </span>
        <WhereLibUsedComponent :lang="lang.WhereLibUsed"></WhereLibUsedComponent>
        <br><br>
        <WhatIsIncludedComponent v-if="selectedRows.length == 1 && selectedType" :parent="'Details'"
          :lang="lang.WhatIsIncluded"></WhatIsIncludedComponent>
      </b-tab>

      <b-tab :title="lang.tab_CamparisonLibraries" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 2">

        <CompareLibrariesComponent :lang="lang.CamparisonLibraries"></CompareLibrariesComponent>

      </b-tab>
      <b-tab :title="lang.tab_CamparisonFiles" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 3">

        <FileComparisonComponent :lang="lang.FileComparison" parent="library"></FileComparisonComponent>
      </b-tab>
      <b-tab v-if="isPinsTable" :title="lang.tab_Pins" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 4">

        <PinsTableComponent :lang="lang.PinsTable" parent="library"></PinsTableComponent>
      </b-tab>


    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'
import TasksComponent from '@/components/shared/TasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import CompareLibrariesComponent from '@/components/shared/CompareLibrariesComponent'
import WhereLibUsedComponent from '@/components/shared/WhereLibUsedComponent'
import WhatIsIncludedComponent from '@/components/shared/WhatIsIncludedComponent'
import FileComparisonComponent from '@/components/shared/FileComparisonComponent'
import PinsTableComponent from '@/components/shared/PinsTableComponent'


export default {
  name: "Content",
  components: {
    TasksComponent,
    WhereUseTableComponent,
    CompareLibrariesComponent,
    WhereLibUsedComponent,
    WhatIsIncludedComponent,
    FileComparisonComponent,
    PinsTableComponent
   

  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    selectedType() {

      if (this.$store.getters.selectedRows.length != 0) {

        if (this.$store.getters.selectedRows[0].col___libraryType == undefined) {
          return false;
        }
        let elem = this.$store.getters.selectedRows[0].col___libraryType.value.display;
        return (elem == LibraryTypes.FOOTPRINT || elem == LibraryTypes.PADSTACK);
      }
      return false;
    },
    libraryType() {
      if (this.$store.getters.selectedRows.length != 0) {
        return this.$store.getters.selectedRows[0].col___libraryType.value.display;
      }
      return false;
    },
    isPinsTable() {
      let ret = false;
      switch (this.libraryType) {
        case LibraryTypes.PART:
          ret = true;
          break;
        // case LibraryTypes.SYMBOL:
        //   ret = true;
        //   break;
        case LibraryTypes.FOOTPRINT:
          ret = true;
          break;
        case LibraryTypes.HDLSYMBOL:
          ret = true;
          break;

        default:

      }
      return ret;
    }
  },
  created() {
    this.getTabIndex();


  },
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    }
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
  },
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails/Right/Content/Content.vue